export var UsageStrategyKey;
(function (UsageStrategyKey) {
    UsageStrategyKey["PROD"] = "production";
    UsageStrategyKey["AZURE"] = "azure";
    UsageStrategyKey["DRUID"] = "druid";
    UsageStrategyKey["FALLBACK_AZURE_PRIMARY"] = "fallback:azure";
    UsageStrategyKey["FALLBACK_DRUID_PRIMARY"] = "fallback:druid";
})(UsageStrategyKey || (UsageStrategyKey = {}));
//# sourceMappingURL=types.js.map